import configReducer from "./configurations/configSlice";
import foryouReducer from "./foryouSlice";
import globalAISlice from "./globalAISlice";
import globalReducer from "./globalSlice";
import globalVideoReducer from "./globalVideoSlice";
import { linkedAccountReducer } from "./linkedAccountSlice";
import memberCenterReducer from "./memberCenterSlice";
import { configureStore } from "@reduxjs/toolkit";
import scriptRewriteReducer from "@pages/aiStudio/ScriptRewrite/scriptRewriteSlice";
import videoCreatingReducer from "@pages/videoCreating/videoCreatingSlice";
import libraryReducer from "@pages/library/librarySlice";

export const store = configureStore({
  reducer: {
    globalReducer,
    globalVideoReducer,
    configReducer,
    foryouReducer,
    memberCenterReducer,
    globalAISlice,
    scriptRewriteReducer,
    videoCreating: videoCreatingReducer,
    libraryReducer,
    linkedAccountReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
